/**
 * <scent-card>: keeps the size quick-pick in sync with the hidden variant
 * input that Horizon's product-form-component submits, and mirrors the
 * selected variant's price and availability in the card.
 *
 * Markup contract (see snippets/scent-card.liquid):
 *   input[name="id"][ref="variantId"]      hidden, submitted to /cart/add
 *   .scent-card__sizes input[type=radio]   value = variant id,
 *                                          data-price, data-title, [data-unavailable]
 *   .scent-card__price-value / -size       price display
 *   add-to-cart-component                  Horizon element with enable()/disable()
 */
class ScentCard extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  /** @param {Event} event */
  #onChange = (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;

    const variantInput = this.querySelector('input[name="id"]');
    if (variantInput instanceof HTMLInputElement) variantInput.value = radio.value;

    const price = this.querySelector('.scent-card__price-value');
    if (price && radio.dataset.price) price.textContent = radio.dataset.price;
    const size = this.querySelector('.scent-card__price-size');
    if (size && radio.dataset.title) size.textContent = `· ${radio.dataset.title}`;

    this.#setAvailability(!radio.hasAttribute('data-unavailable'));
  };

  /** @param {boolean} available */
  #setAvailability(available) {
    const atc = this.querySelector('add-to-cart-component');
    const button = atc?.querySelector('button');
    if (!atc || !button) return;

    const label = available ? this.dataset.addText : this.dataset.soldOutText;
    const textNode = Array.from(button.childNodes).find(
      (n) => n.nodeType === Node.TEXT_NODE && n.textContent?.trim()
    );
    if (textNode && label) textNode.textContent = label;

    if (available) {
      typeof atc.enable === 'function' ? atc.enable() : button.removeAttribute('disabled');
    } else {
      typeof atc.disable === 'function' ? atc.disable() : button.setAttribute('disabled', '');
    }
  }
}

if (!customElements.get('scent-card')) customElements.define('scent-card', ScentCard);
